import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ResetAssetManagamentStateAction } from '../state/AssetManagementState';
import { ResetCustomerStateAction } from '../state/CustomerInfoState';
import { ResetTranslationStateAction } from '../state/TranslationState';
import { ResetDealerStateAction } from '../state/DealerState';
import { UnlockUserManagementStateAction } from '../state/UserManagementState';
import { ResetCasingDropdownStateAction } from '../state/CasingDropdownState';

@Injectable({
  providedIn: 'root'
})
export class StateManagementService {
  public store = inject(Store);

  resetStateActions = [
    ResetTranslationStateAction,
    ResetCustomerStateAction,
    ResetAssetManagamentStateAction,
    ResetCasingDropdownStateAction,
    ResetDealerStateAction,
    UnlockUserManagementStateAction
  ];

  resetAllStates() {
    this.resetStateActions.forEach((resetAction) => {
      this.store.dispatch(resetAction);
    });
  }
}
